import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useVisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem("visit_logged")) return;

    const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID;
    if (!projectId) return;

    const url = `https://${projectId}.supabase.co/functions/v1/log-site-visit`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        referrer: document.referrer || null,
        page_path: location.pathname || "/",
      }),
    }).catch(() => {});

    sessionStorage.setItem("visit_logged", "1");
  }, []);
};
